export default {
    'AUTH.LINK_SENT.TITLE': 'Link sent!',
    'AUTH.LINK_SENT.ASIDE': 'Check your mailbox, if your account exists you will get an email with the link to create' +
        ' a new password.',
    'AUTH.LINK_SENT.BACK': 'Back to log in',
};
